import { useTranslation } from '@framework/i18n';
import { isEmpty } from 'lodash';
import { useEffect, useMemo, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useBreadcrumbs } from './BreadcrumbContext';

export interface IBreadcrumbDocumentMetadataProps {}

/**
 * Tiene allineati i breadcrumbs con il titolo del documento HTML,
 * tramite helmet.
 */
export function BreadcrumbDocumentMetadata(
  props: IBreadcrumbDocumentMetadataProps,
) {
  // sostituito con titolo statico per traduzioni
  // const defaultTitle = useRef(document.title).current;

  const items = useBreadcrumbs();
  const { t } = useTranslation();

  const title = useMemo(
    () =>
      items && items.length > 0
        ? [...items]
            .reverse()
            .map(b => b.title)
            .join(' - ')
        : undefined,
    [items],
  );

  // Annuncio per l'accessibilità.
  // Non vogliamo che il titolo si aggiorni se è vuoto, altrimenti
  // NVDA/VoiceOver annunciano "Navigato a" senza titolo.
  const [announcement, setAnnouncement] = useState<string>('');
  useEffect(() => {
    if (!isEmpty(title)) {
      setAnnouncement(
        t('route-announcer.nav-to-page', 'Navigato a {{title}}', { title }),
      );
    }
  }, [title, t]);

  return (
    <>
      <Helmet>
        {/* Titolo HTML */}
        {title && (
          <title>
            {title} -{' '}
            {t('html.head.title', 'Portale dei Procedimenti | Frontoffice')}
          </title>
        )}
      </Helmet>
      {/* Annuncio per l'accessibilità */}
      <div
        aria-live="polite"
        aria-atomic="true"
        className="sr-only"
        style={{ position: 'absolute', left: '-9999px' }}
      >
        {announcement}
      </div>
    </>
  );
}
